import React from 'react'
import styled from 'styled-components'

const StyledInput = styled.input`
  width: ${props => props.width};
  height: 40px;
  margin: auto;
  margin-bottom: 30px;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #4466ca;
  outline: none;
  font-family: 'Bellota Text', cursive;

  :focus, :hover {
    border-color: #171d45;
  }
`


const Input = (
    {
        name = "",
        type = "text",
        onChange = null,
        disabled = false,
        defaultValue,
        width = "100%",
        placeholder = ""
    }) => {
    return <StyledInput type={type} name={name} onChange={onChange} disabled={disabled} defaultValue={defaultValue}
                        width={width}
                        placeholder={placeholder}/>
}

export default Input
